module.exports = __webpack_public_path__ + "img/recupel.3310835c.png";